import { Form } from "redux-form";
import styled from "styled-components";

const StyledForm = styled(Form)`
  width: 100%;
`;

export default StyledForm;
